import Caption from '@zenbusiness/common-components/Caption';
import PropTypes from 'prop-types';

import {
  GridItem,
  WorksheetContainer,
  StyledTitle
} from '#client/pages/EducationStudio/components/Interactive/WorksheetActivity/worksheetComponents';
import { useBreakpoints } from '#client/pages/EducationStudio/hooks/useBreakpoints';

import { StyledNextButton } from './useStyles';

export const MAX_CHARACTER_COUNT = 75;
export const LARGER_MAX_CHARACTER_COUNT = 140;

export const ExercisePage = ({
  caption,
  title,
  summary,
  presentation,
  buttonText,
  isButtonDisabled,
  onNext,
  children
}) => {
  const {
    sizes: { isMobile }
  } = useBreakpoints();

  return (
    <WorksheetContainer container>
      {!isMobile && (
      <GridItem item xs={12} sm={6}>
        {presentation}
      </GridItem>
      )}
      <GridItem item xs={12} sm={6}>
        <Caption size="md" bold>{caption}</Caption>
        <StyledTitle variant={isMobile ? 'lg-alt' : 'md-alt'}>
          {title}
        </StyledTitle>
        {summary}
        {isMobile && presentation}
        {children}
      </GridItem>
      {isMobile && (
        <GridItem item xs={12}>
          <StyledNextButton
            variant="contained"
            color="primary"
            size="medium"
            disabled={isButtonDisabled}
            onClick={() => onNext()}
          >
            {buttonText}
          </StyledNextButton>
        </GridItem>
      )}
    </WorksheetContainer>
  );
};

ExercisePage.propTypes = {
  caption: PropTypes.string,
  title: PropTypes.string,
  summary: PropTypes.node,
  presentation: PropTypes.node.isRequired,
  buttonText: PropTypes.string,
  isButtonDisabled: PropTypes.bool,
  onNext: PropTypes.func
};

ExercisePage.defaultProps = {
  caption: '',
  title: '',
  summary: null,
  buttonText: '',
  isButtonDisabled: false,
  onNext: () => {}
};
